import React from 'react';

import { Box, Text, StyledOcticon } from '@primer/components'
import { Check, Diff } from '@primer/octicons-react'
import ReactDiffViewer from 'react-diff-viewer';

import Advice from '../Advice'


export default function(props) {
  const word = props.messageIds.length === 1 ? 'type' : 'types'
  return (
    <Box as="span" style={{verticalAlign: 'middle'}} className="f4">
      <StyledOcticon icon={Diff} size={20} marginRight={'6px'} marginLeft={'10px'}/>
      <Text>Changes</Text>
      <Box className="mb-2 mt-2" style={{width: '100%'}}>
        <ReactDiffViewer
          oldValue={props.diffBefore}
          newValue={props.diffAfter}
          splitView={false}
          compareMethod={'diffLines'}
        />
        <Text as="p" className="mt-4 mb-2">
          <StyledOcticon icon={Check} size={20} marginRight={'6px'} marginLeft={'10px'}/>
          <Text>{props.messageIds.length} {word} of issue fixed</Text>           
        </Text>
        {
          props.messageIds.map(messageId => (
            <Advice
              key={messageId}
              messageId={messageId}
              style={{borderTop: 'none'}}
              items={[]}
              defaultOpen={false}
              showInstallPrompt={false}
              showDiff={false}
              showLink={false}
              showHeaderCount={true}
            />
          ))
        }
      </Box>
      {props.nextButton}
    </Box>
  )
}